/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-08-22 17:27:44
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\register\locales\en-US.ts
 */
export default {
  'page.user.register.form-item-username': 'Registered Email',
  'page.user.register.form-item-username.required':
    'Please input your Email',
  'page.user.register.form-item-password': 'Registered Password',
  'page.user.register.form-item-password.required':
    'Please input your password',
  'page.user.register.form-item-confirmpassword': 'Confirm Password',
  'page.user.register.form-item-confirmpassword.compare':
    'The two passwords that you entered do not match!',
  'page.user.register.form.title': 'Account Registration',
  'page.user.register.form.btn-submit': 'Register',
  'page.user.register.form.btn-jump': 'Already have an account?',
  'page.user.register.form.register-success':
    'Registered successfully, please log in!',
  'page.user.register.form.agreement.start': 'I have read and agree',
  'page.user.register.form.agreement.agre': '《User agreement》',
  'page.user.register.form.agreement.desc': '《User privacy description》'
};
